export default __webpack_public_path__ + "static/media/14.c9c1467e.png";